<template>
  <div class="accord-mobile">
    <div class="navbar-collapse collapse clearfix dropdown-margin custom-collapse">
      <div class="accordion accordion-flush" id="accordionFlushExample">
        <div class="navbar-header accord-logo">
          <div class="mobile-logo py-5">
            <router-link to="/">
              <img
                src="/assets/images/logos/opalina_logo.png"
                alt="Logo"
                title="Logo"
              />
            </router-link>
          </div>
          <div class="mobile-lang-switcher">
            <LanguageSwitcher />
          </div>
          <button
            type="button"
            class="navbar-toggle"
            data-bs-toggle="collapse"
            data-bs-target=".custom-collapse"
            aria-expanded="true"
          >
            <span class="icon-bar anticlock1"></span>
            <span class="icon-bar anticlock"></span>
          </button>
        </div>
        <h2 class="service-acc">{{ $t("menu.services") }}</h2>
        
        <div
          v-for="(section, index) in mobileMenuSections"
          :key="section.id"
          class="accordion-item"
        >
          <h2 class="accordion-header" :id="`flush-heading${index}`">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              :data-bs-target="`#flush-collapse${index}`"
              aria-expanded="false"
              :aria-controls="`flush-collapse${index}`"
            >
              {{ $t(section.title) }}
            </button>
          </h2>
          <div
            :id="`flush-collapse${index}`"
            class="accordion-collapse collapse"
            :aria-labelledby="`flush-heading${index}`"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body">
              <ul class="m-col">
                <li v-for="link in section.links" :key="link.href">
                  <router-link :to="link.href" @click="handleMenuClick">
                    {{ $t(link.label) }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div class="query-mob">
          <h2>{{ $t("mobile.businessQueries") }}</h2>
          <h4>{{ $t("mobile.emailUs") }}</h4>
          <p>
            <a href="mailto:contact@opalina.com?subject=Connect with us">
              contact@opalina.com
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageSwitcher from "../LanguageSwitcher.vue";
import { nextTick } from "vue";

export default {
  name: "HeaderMobile",
  components: {
    LanguageSwitcher,
  },
  setup() {
    const mobileMenuSections = [
      {
        id: "banking",
        title: "menu.bankingExpertise",
        links: [
          {
            href: "/enterprise-banking-services#RealTimePayments",
            label: "services.banking.realTimePayments"
          },
          {
            href: "/enterprise-banking-services#InterbankPayments",
            label: "services.banking.interbankPayments"
          },
          {
            href: "/enterprise-banking-services#BankingExpertise",
            label: "services.banking.qrBasedPayments"
          },
          {
            href: "/enterprise-banking-services#PaymentRoutingandWorkflows",
            label: "services.banking.paymentRoutingWorkflows"
          },
          {
            href: "/enterprise-banking-services#BankingExpertise",
            label: "services.banking.accountingServices"
          },
          {
            href: "/enterprise-banking-services#BankingExpertise",
            label: "services.banking.reconciliationServices"
          },
          {
            href: "/enterprise-banking-services#CorporateBankingPortal",
            label: "services.banking.corporateBankingPortal"
          },
          {
            href: "/enterprise-banking-services#ComplianceandSecurity",
            label: "services.banking.complianceSecurity"
          }
        ]
      },
      {
        id: "enterprise",
        title: "menu.enterpriseExpertise",
        links: [
           {
            href: "enterprise-banking-services#DataProcessing",
            label: "services.enterprise.dataProcessing"
          },
          {
            href: "enterprise-banking-services#CRMBusinessSolutions",
            label: "services.enterprise.CRMERPBusinessSolutions"
          },
          {
            href: "enterprise-banking-services#DataEngineering",
            label: "services.enterprise.dataEngineering"
          },
          {
            href: "enterprise-banking-services#BusinessIntelligence",
            label: "services.enterprise.businessIntelligence"
          },
          
          {
            href: "/enterprise-banking-services#EnterpriseArchitectureAssessmentandDevelopment",
            label: "services.enterprise.architectureAssessment"
          },
          {
            href: "/enterprise-banking-services#ProcessandWorkflowAutomation",
            label: "services.enterprise.processWorkflowAutomation"
          },
          {
            href: "/enterprise-banking-services#CloudMigrationServices",
            label: "services.enterprise.cloudMigrationServices"
          },
          {
            href: "/enterprise-banking-services#CentralizedEventMonitoringHub",
            label: "services.enterprise.centralizedEventMonitoring"
          },
          {
            href: "/enterprise-banking-services#LegacySystemTransformation",
            label: "services.enterprise.legacyTransformation"
          }
         
        ]
      },
      {
        id: "digital",
        title: "menu.digitalServices",
        links: [
          {
            href: "/service-digital#MobileAppDevelopment",
            label: "services.digital.mobileAppDevelopment"
          },
          {
            href: "/service-digital#FrontendDevelopment",
            label: "services.digital.frontendDevelopment"
          },
          {
            href: "/service-digital#BackendDevelopment",
            label: "services.digital.backendDevelopment"
          },
          {
            href: "/service-digital#APIDevelopment",
            label: "services.digital.apiDevelopment"
          },
          {
            href: "/service-digital#CrossPlatformAppDevelopment",
            label: "services.digital.crossPlatformAppDevelopment"
          },
          {
            href: "/service-digital#DigitalAssetManagement",
            label: "services.digital.digitalAssetManagement"
          },
          {
            href: "/service-digital#OurProducts",
            label: "services.digital.ourProducts.title"
          }
        ]
      },
      {
        id: "ai",
        title: "menu.aiAutomations",
        links: [
          {
            href: "/ai-automations#chatbots",
            label: "services.ai.chatbotsAgents"
          },
          {
            href: "/ai-automations#hrautomation",
            label: "services.ai.hrAutomation"
          },
          {
            href: "/ai-automations#ocr",
            label: "services.ai.ocrDocumentProcessing"
          },
          {
            href: "/ai-automations#workfloworchestration",
            label: "services.ai.workflowOrchestration"
          },
          {
            href: "/ai-automations#itsupport",
            label: "services.ai.itSupportAssistant"
          },
          {
            href: "/ai-automations#intelligentprocess",
            label: "services.ai.intelligentProcessAutomation"
          },
          {
            href: "/ai-automations#itproductionsupport",
            label: "services.ai.itProductionSupport"
          },
          {
            href: "/ai-automations#internalknowledge",
            label: "services.ai.internalKnowledgeBase"
          }
        ]
      },
      {
        id: "cloud",
        title: "menu.cloudServices",
        links: [
          {
            href: "/service-cloud#cloudmigration",
            label: "services.cloud.cloudMigrationModernization"
          },
          {
            href: "/service-cloud#devops",
            label: "services.cloud.devopsAsService"
          },
          {
            href: "/service-cloud#paas",
            label: "services.cloud.paas"
          },
          {
            href: "/service-cloud#cloudmonitoring",
            label: "services.cloud.cloudMonitoring"
          },
          {
            href: "/service-cloud#cloudsecurity",
            label: "services.cloud.cloudSecurity"
          },
          {
            href: "/service-cloud#multicloud",
            label: "services.cloud.multiCloud"
          }
        ]
      }
    ];

    const handleMenuClick = () => {
      nextTick(() => {
        if (window.$) {
          $(".custom-collapse").collapse("hide");
          $(".accordion-collapse.show").collapse("hide");
          $(".modal-backdrop").remove();
          $(".navbar-toggle")
            .removeClass("collapsed")
            .attr("aria-expanded", "false");
        }
      });
    };

    return {
      mobileMenuSections,
      handleMenuClick,
    };
  },
};
</script>
